import { render, staticRenderFns } from "./DealMatrix.vue?vue&type=template&id=e3a759fa&scoped=true&"
import script from "./DealMatrix.vue?vue&type=script&lang=js&"
export * from "./DealMatrix.vue?vue&type=script&lang=js&"
import style0 from "./DealMatrix.vue?vue&type=style&index=0&id=e3a759fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a759fa",
  null
  
)

export default component.exports